import { create } from 'zustand';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';

export type OldData = {
  full_name?: string;
  title?: string;
  email?: string;
  phone_number?: string;
};

export type MergeData = {
  merge_company_profile_id?: string;
  merge_company_name?: string;
  merge_company_jurisdiction?: string;
  merge_company_profile_type?: Array<string>;
};
export interface ICompanyContribute {
  open: boolean;
  type: TypeContributeCompany | null;
  additionalData: { oldData?: OldData; mergeData?: MergeData };
}

export interface IFormSearchAction {
  handleCloseContribute: () => void;
  handleOpenContribute: (type: TypeContributeCompany, additionalData?: { oldData?: OldData; mergeData?: MergeData }) => void;
}

export const useCompanyContribute = create<ICompanyContribute & IFormSearchAction>((set) => {
  return {
    open: false,
    type: null,
    additionalData: {
      oldData: {
        full_name: '',
        title: '',
        email: '',
        phone_number: '',
      },
      mergeData: {
        merge_company_profile_id: '',
        merge_company_name: '',
        merge_company_jurisdiction: '',
        merge_company_profile_type: [],
      },
    },
    handleCloseContribute: () => set(() => ({ open: false, type: null })),
    handleOpenContribute: (type: TypeContributeCompany, additionalData?: { oldData?: OldData; mergeData?: MergeData }) =>
      set(() => ({ open: true, type, additionalData })),
  };
});
